module.exports = __webpack_public_path__ + "img/proImg1.8a4dbd1a.png";